import { render, staticRenderFns } from "./EventBanners.vue?vue&type=template&id=25848df4&scoped=true"
import script from "./EventBanners.vue?vue&type=script&lang=js"
export * from "./EventBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25848df4",
  null
  
)

export default component.exports